import {} from '@/pages/Admin/QuestionnaireTemplates/Index';
import { api } from './client';
import {
  QuestionnaireSectionProps,
  QuestionnaireTemplateDetailProps,
  QuestionnaireTemplateProps,
  QuestionProps,
  UserApplicationData,
} from '@/types/questionnaire';

export const questionnaireTemplateApi = {
  getAll: (): Promise<QuestionnaireTemplateProps[]> =>
    api.get('/admin/questionnaire_templates'),
  getById: (id: number): Promise<QuestionnaireTemplateDetailProps> =>
    api.get(`/admin/questionnaire_templates/${id}`),
  updateById: (
    id: number,
    updates: Pick<QuestionnaireTemplateProps, 'title' | 'description'>
  ): Promise<QuestionnaireTemplateProps> =>
    api.patch(`/admin/questionnaire_templates/${id}`, {
      title: updates.title,
      description: updates.description,
    }),
};

export const questionnaireSectionApi = {
  getById: (id: number): Promise<any> =>
    api.get(`/admin/questionnaire_sections/${id}`),
  create: (
    templateId: number,
    data: Partial<QuestionnaireSectionProps>
  ): Promise<QuestionnaireSectionProps> =>
    api.post(
      `/admin/questionnaire_templates/${templateId}/questionnaire_sections/`,
      { section: data }
    ),
  update: (id: number, data: Partial<QuestionnaireSectionProps>) =>
    api.patch(`/admin/questionnaire_sections/${id}`, { section: data }),
  delete: (id: number): Promise<void> =>
    api.delete(`/admin/questionnaire_sections/${id}`),
  reorder: (sections: Array<{ id: number; section_order: number }>) =>
    api.post(`/admin/questionnaire_sections/reorder`, { sections }),
};

export const questionApi = {
  getById: (id: number): Promise<QuestionProps> =>
    api.get(`/admin/questions/${id}`),
  create: (
    sectionId: number,
    data: Partial<QuestionProps>
  ): Promise<QuestionProps> =>
    api.post(`/admin/questionnaire_sections/${sectionId}/questions`, {
      question: data,
    }),
  update: (id: number, data: Partial<QuestionProps>): Promise<QuestionProps> =>
    api.patch(`/admin/questions/${id}`, { question: data }),
  delete: (id: number): Promise<void> => api.delete(`/admin/questions/${id}`),
  reorder: (questions: Array<{ id: number; order: number }>) =>
    api.post(`/admin/questions/reorder`, { questions }),
};

export const questionnaireApi = {
  create: () => api.post('/questionnaire'),
  saveSection: (data: {
    responses: Array<{
      question_id: number;
      response_value: string | string[];
    }>;
    current_step: number;
  }) => api.patch('/questionnaire', data),
  reapply: (): Promise<{ success: boolean; redirect: string }> =>
    api.post('/questionnaire/reapply'),
};

export const userApplicationApi = {
  getById: (userId: number): Promise<UserApplicationData> =>
    api.get(`/admin/users/${userId}/application`),
  getMenteeProfile: (menteeId: number): Promise<UserApplicationData> =>
    api.get(`/matches/${menteeId}/mentee_profile`),
};
